import styled from 'styled-components';
import {
    PlayerNameWrapper,
    PlayerPregameWrapper,
    PlayerStatsWrapper,
    PlayerMatchupWrapper as ComponentMatchupWrapper,
    PlayerInfoWrapper
} from '@mlb/react-patterns/components/PlayerMatchup/playerMatchup.style';
import { ImageWrapper } from '@mlb/react-patterns/components/Image/image.style';

export const PlayerMatchupWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    margin: 0 auto;

    ${ImageWrapper} {
        display: block;
    }

    ${ComponentMatchupWrapper} {
        width: fit-content;
    }

    ${PlayerNameWrapper} {
        font-size: 14px;
        color: var(--gameday-primary-font-color);
        font-weight: 700;
        display: inline-block;
        white-space: nowrap;
        height: 19px;
    }

    ${PlayerPregameWrapper} {
        display: inline-block;
        font-size: 12px;
        font-weight: 500;
        line-height: 12px;
        color:var(--gameday-secondary-font-color);
        margin-top: 4px;
    }

    ${PlayerStatsWrapper} {
        font-size: 14px;
        color:var(--gameday-secondary-font-color);
        white-space: nowrap;
        height: 12px;
        margin-top: 4px;
    }

    ${PlayerInfoWrapper} {
        margin-top: 0;
        white-space: nowrap;
        height: 14px;
    }
`;

export const NameWrapper = styled(PlayerNameWrapper)`
    display: block !important;
`;

export const StatsWrapper = styled(PlayerStatsWrapper)`
    display: block !important;
`;

export const MatchupWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    padding: 18px 0;
    width: 100%;
    margin: 0;
    gap: 7px;
`;

export const PlayerMatchupStatsWrapper = styled.span`
    text-transform: uppercase;
    vertical-align: top;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    height: 12px;
    margin-top: 4px;
`;

export const StatsDividerWrapper = styled.span`
    margin: 0 5px;
    color: var(--gameday-divider-color);
`;

export const MatchupLabel = styled.span`
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    color:var(--gameday-secondary-font-color);
    margin-right: 3px;
`;
